import { createFileRoute } from '@tanstack/react-router'

import { conflictsQuery } from '../lib/queries'
import { Notes } from '../screens/Notes'

export const Route = createFileRoute('/notes')({
  loader: ({ context }) => context.queryClient.ensureQueryData(conflictsQuery()),
  component: Notes,
})
